import React, { useRef } from 'react';
import { useWidthResizableField } from '../../../hook/useWidthResizableField';

export const AddressElement = function FromElement({ element, setPosition }) {
  const streetInputRef = useRef();

  // The Street row spans the whole field (`grid-column: 1 / -1`) while City and
  // State share the row below it, one grid column each. So the handle only has
  // to change the field's width: the street input follows it, and the two below
  // stay at half of it without being sized by hand.
  useWidthResizableField(streetInputRef, element, setPosition);

  return (
    <>
      <div className={`form-grid-full-name form-grid-full-name-${element.options.size}`} style={{ width: '100%' }}>
        <div className="form-grid-item" style={{ gridColumn: '1 / -1' }}>
          <label htmlFor={element.id + element.inputs[0].name} className="form-label">
            {element.inputs[0].label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
          </label>
          {/* `ResizableField` inserts the handle right after the input, so the
              input needs a box of its own to be positioned against — see
              `.address-street-resize-wrapper` in form-builder/layout.scss. */}
          <div className="address-street-resize-wrapper">
            <input
              name={element.inputs[0].name}
              id={element.id + element.inputs[0].name}
              ref={streetInputRef}
              type="text"
              readOnly
              className="form-control"
            />
          </div>
        </div>
        <div className="form-grid-item">
          <label htmlFor={element.id + element.inputs[1].name} className="form-label">
            {element.inputs[1].label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
          </label>
          <input name={element.inputs[1].name} id={element.id + element.inputs[1].name} type="text" readOnly className="form-control" />
        </div>
        <div className="form-grid-item">
          <label htmlFor={element.id + element.inputs[2].name} className="form-label">
            {element.inputs[2].label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
          </label>
          <input name={element.inputs[2].name} id={element.id + element.inputs[2].name} type="text" readOnly className="form-control" />
        </div>
      </div>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
